<template>
  <div v-if="!this.$store.state.loadingChartData" :loading="this.$store.state.loadingChartData">
    <canvas id="migrationChart" style="max-height: 35rem" :loading="this.$store.state.loadingChartData"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js";

export default {
  name: "migration-chart",
  props: {
    chartType: String,
    chartData: Object,
    chartOptions: Object,
  },
  components: {
    Chart,
  },
  data() {
    return {
      responsive: true,
      options: {
        legend: {
          display: false,
        },
        scales: {
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "Net Migration Per 1000 Population",
              },
            },
          ],
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "Year",
              },
            },
          ],
        },
        hoverOffset: 4,
      },
      sidebarStore: false,
    };
  },
  mounted() {
    let { chartType, chartData, chartOptions } = this;
    this.chartConstructor(chartType, chartData, chartOptions);
  },
  methods: {
    chartConstructor(chartType, chartData, chartOptions) {
      const chartElement = document.getElementById("migrationChart");
      const chart = new Chart(chartElement, {
        type: "line",
        data: chartData,
        options: this.options,
      });
    },
  },
};
</script>
